import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface PhysicalCardInfoTooltipProps {
  openLeft: boolean
}

const PhysicalCardInfoTooltip: React.FC<PhysicalCardInfoTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        {translate(
          '${availableCredit} is the amount you have left to spend on your physical card.',
          {
            availableCredit: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                {translate('Available Credit')}
              </span>
            ),
          },
        )}
      </p>
    </Tooltip>
  )
}

export default PhysicalCardInfoTooltip
